import React from "react";

import { theme } from "styles/theme";
import { Icon } from "../../Icon";
import { Input } from "../../Input";

import { InputFieldProps } from "../types";
import { ClearButtonMobile, InputFieldWrapperMobile } from "./styles";

/**
 * Componente InputField (Mobile)
 *
 * Versão adaptada para layouts móveis, mantendo as funcionalidades do campo de entrada.
 */
export const InputFieldMobile: React.FC<InputFieldProps> = ({
  placeholder = "Search...",
  value,
  onChange,
  onFocus,
  onClear,
  showClearButton = true,
  iconColor,
}) => (
  <InputFieldWrapperMobile>
    <Input
      backgroundColor={theme.colors.transparent}
      borderColor={theme.colors.transparent}
      placeholder={placeholder}
      textColor={iconColor}
      onChange={onChange}
      onFocus={onFocus}
      value={value}
      size="medium"
      isFakeFocus
    />
    {showClearButton && value && (
      <ClearButtonMobile onClick={onClear} aria-label="Clear input">
        <Icon library="md" svgName="close-x" size="small" />
      </ClearButtonMobile>
    )}
  </InputFieldWrapperMobile>
);
